import type { ColDef } from 'ag-grid-community'

import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { textColDef } from '~/utils/table'

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'placeholder',
    headerName: 'Placeholder Id',
    suppressHeaderMenuButton: true,
  }),
  textColDef(TextCellRenderer, {
    field: 'locale',
    headerName: 'Locale',
    suppressHeaderMenuButton: true,
  }),
  textColDef(TextCellRenderer, {
    field: 'rule',
    headerName: 'Rule',
    suppressHeaderMenuButton: true,
  }),
  textColDef(TextCellRenderer, {
    field: 'rule_value',
    headerName: 'Rule value',
    suppressHeaderMenuButton: true,
  }),
  textColDef(TextCellRenderer, {
    field: 'translation_value',
    headerName: 'Translation value',
    suppressHeaderMenuButton: true,
  }),
]

export default columns
